<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-9">
      <span class="iso-header">
        {{'bikeshop.shop_setup.card_headers.text_message_integration' | translate}}
      </span>
    </div>
  </div>
  <div class="content">


    <div class="sub-header">
      {{"bikeshop.shop_setup.card_description.text_message_integration" | translate}}
    </div>
    <!-- loader -->
    <div *ngIf="busy">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
        animationDuration=".5s"></p-progressSpinner>
    </div>

    <!-- current connected platform -->
    <div class="row margin-top-8 margin-left-8" *ngIf="connectedPlatform > 0 && !busy">
      <!-- ikeono -->
      <div class="col-8 col-sm-8 col-md-8 col-lg-8 mb-4" *ngIf="connectedPlatform == 1">
        <div class="col-md-6">
          <label for="storeType">{{"messaging.select_store" | translate}}:</label>
          <p-dropdown [options]="storeTypes" [(ngModel)]="selectedStoreType" optionLabel="name"
            placeholder="{{'messaging.select_store' | translate}}" [showClear]="true"
            (onChange)="onStoreTypeChange($event)">
          </p-dropdown>
        </div>
      </div>
      <!-- ikeono -->

      <!-- podium -->
      <div class="col-8 col-sm-8 col-md-8 col-lg-8 mb-4" *ngIf="connectedPlatform == 2">
        <app-link-podium [partner]="partner" [currentData]="selectedStoreType"></app-link-podium>
      </div>
      <!-- podium -->

      <!-- twilio -->
      <div class="col-8 col-sm-8 col-md-8 col-lg-8 mb-4" *ngIf="connectedPlatform == 3">
        <app-link-twilio [partner]="partner" [currentData]="selectedStoreType"></app-link-twilio>
      </div>
      <!-- twilio -->

      <!-- coax -->
      <div class="col-8 col-sm-8 col-md-8 col-lg-8 mb-4" *ngIf="connectedPlatform == 4">
        <app-link-coax [partner]="partner" [currentData]="selectedStoreType"></app-link-coax>
      </div>
      <!-- coax -->

      <div class="margin-top-24 col-4 col-sm-4 col-md-4 col-lg-4 mb-4">
        <button pButton class="p-button-raised iso-round-button" style="float:right" (click)="removePlatform()"
          [disabled]="disconnectBusy">
          {{'messaging.disconnect' | translate}}
        </button>
      </div>
    </div>



    <!-- available platforms to connect with -->
    <div class="row margin-top-32" *ngIf="connectedPlatform == 0 && !busy">
      <div *ngFor="let platform of textMessagingPlatforms" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 clickable-card"
        (click)="configurePlatform(platform.id)">
        <div class="platform-card">
          <div class="platform-logo">
            <img [src]="platform.logo" [alt]="platform.name" />
          </div>
          <div class="platform-details">
            <h3 class="platform-name">{{platform.name}}</h3>
            <p class="platform-description">{{platform.description}}</p>
            <button pButton class="p-button-raised connect-button">
              {{'messaging.connect' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog key="text_message_integration_confirmation"></p-confirmDialog>